<template>
    <li
        class="member-child-selector__child-list-item"
        @click.prevent="changeMemberBeingViewed"
        v-html="decode(member.name)"
    ></li>
</template>

<script>
  import FuelUtilities from '../../../FuelUtilities';

  export default {
    name: "ChildOption",
    mixins: [FuelUtilities],
    props: ['member'],
    methods: {
      changeMemberBeingViewed() {
        this.$emit('selection');
        this.$store.dispatch('auth/changeMemberBeingViewed', {
          member_id: this.member.business_id
        });
      },
    },
  };
</script>

